import { CALENDAR_DOC, HOUSEHOLD_DOC, PERSONAL_CALENDAR_DOC_PREFIX } from '@awwyeah/shared';
import type { WebModule } from '../registry';
import { CalendarPage } from './CalendarPage';

/**
 * Calendar module (client side, WS-4). Registry-driven: one nav entry, one route, three doc
 * subscriptions — the `calendar` doc it owns and the `household` doc it *reads* for member
 * colours and birthdays (DESIGN-BRIEF §4 screen 9). Nothing outside this directory changes
 * except the one registration line in `modules/index.ts`.
 */
export const calendarWebModule: WebModule = {
  id: 'calendar',
  nav: { label: 'Calendar', path: '/calendar', icon: '📅', order: 10 },
  routes: [{ path: '/calendar', component: CalendarPage }],
  docs: [CALENDAR_DOC, PERSONAL_CALENDAR_DOC_PREFIX, HOUSEHOLD_DOC],
};

export { CalendarPage } from './CalendarPage';
export { CalendarFeedSection } from './CalendarFeedSection';
/** The month grid as an embeddable card — the digest's, and the module's one such export. */
export { CalendarSection } from './CalendarSection';
